export default {
  en: {
    recoverChoice: {
      title: 'Choose your preferred<br />access recovery method',
      emailSubtitle: 'Via e-mail',
      emailDescription: 'We will send you an e-mail with verification link',
      emailButtonText: 'Via e-mail',
      phoneSubtitle: 'Via SMS / Mobile',
      phoneDescription: 'We will send you SMS with verification code',
      phoneButtonText: 'Via SMS'
    },
    recoverBy: {
      emailTitle: 'Enter your e-mail address to recover access',
      emailSubmitButtonText: 'Send e-mail',
      phoneTitle: 'Enter your mobile number to recover access',
      phoneSubmitButtonText: 'Send SMS'
    },
    checkRecoverData: {
      title: 'Sent!<br />Check Your phone',
      description: 'We’ve sent an SMS with code to {phone}',
      submitButton: 'Submit Code',
      resendButton: 'Resend SMS',
      seconds: 'SEC.'
    },
    resetRecoverType: {
      or: 'OR',
      chooseEmailRecover: 'Choose e-mail',
      choosePhoneRecover: 'Choose SMS',
      recoveryOptionText: 'recovery option',
      havingProblemText: 'Having problem?',
      contactSupportLinkText: 'Contact support'
    },
    emailSent: {
      title: 'Sent!<br />Check your mail',
      description: 'We’ve sent an Email with “recovery link” to {email}',
      note: '(Before resend check your “Spam” folder)',
      tryAgain: 'Try again',
      seconds: 'SEC.'
    },
    loader: {
      title: 'Please wait while processing your request!'
    },
    enterNewPassword: {
      title: 'Enter your new password',
      subtitle: 'At least 8 symbols and must contain a number',
      savePasswordButton: 'Save password'
    },
    error: {
      general: 'Oops...<br />something went wrong!',
      button: 'Try again',
      recoveryCodeInvalidOrExpired: 'Provided code invalid/expired!',
      recoveryCodeError: 'Error while checking provided recover data!',
      savePasswordError: 'Error while saving new password!',
      recoverByEmailError: 'Error while checking user email!',
      recoverByEmailInvalid: 'User with provided email doesn\'t exist!',
      recoverByPhoneError: 'Error while checking user phone!',
      recoverByPhoneInvalid: 'User with provided phone doesn\'t exist!',
      recoverByPhoneInvalidDescr: 'Please try to enter number in different format'
    },
    lockdown: {
      message: 'To recover access to your profile, please reach<br />customer care specialists, we’ll help you.',
      phone: '912 907 788',
      email: 'info@vivus.lv',
      chat: 'Chat with us',
      workingHours: 'Working hours: 8:00 — 22:00  |  Holidays: 9:00 — 20:00 '
    },
    form: {
      emailRecover: {
        emailInput: {
          label: 'Email'
        },
        errors: {
          required: 'is required!',
          invalid_email: 'is invalid!'
        }
      },
      phoneRecover: {
        phoneInput: {
          label: 'Phone'
        },
        errors: {
          incorrect_format: 'format is incorrect!',
          required: 'is required!',
          too_long: 'is too long!'
        }
      },
      checkRecoverData: {
        codeInput: {
          label: 'Recovery code'
        },
        errors: {
          required: 'is required!',
          must_be_number: 'must be a number!',
          too_short: 'is too short!',
          too_long: 'is too long!'
        }
      },
      enterNewPassword: {
        passwordInput: {
          label: 'Password'
        },
        errors: {
          required: 'is required!',
          too_short: 'is too short!',
          too_long: 'is too long!',
          password_contains_space: 'must not contain spaces!',
          password_needs_number_or_special: 'needs a number or special character!',
          password_needs_small_letter: 'must contain small letters!',
          password_needs_capital_letter: 'must contain capital letters!'
        }
      }
    },
    common: {
      backToSignInLinkText: 'Back to Sign in'
    },
    newPasswordSaved: {
      title: 'Password successfully changed',
      buttonText: 'Go to log in'
    }
  }
};